import { fetchData } from '../../services/apiClient';
import { API_ENDPOINTS } from '../../services/ApiConfig';

interface FilterResponse {
  data: {
    disabled_keys: Record<string, any[]>;
    enabled_keys: Record<string, any[]>;
  };
}

export const fetchFilterData = async (payload: any) => {
  return fetchData<FilterResponse>(API_ENDPOINTS.SCENARIO_OUTPUT.FETCH_OUTPUT_DYNAMIC_FILTER, payload);
};
